import { swpPeriodicWithdrawal } from "../../engine/calculations";

const FREQUENCY_LABELS = { monthly: "month", quarterly: "quarter", annual: "year" };

const config = {
  key: "swp-periodic",
  title: "SWP Periodic Withdrawal",
  category: "Retirement & Income",
  description: "See how long a corpus lasts when you withdraw monthly, quarterly, or annually instead.",
  fields: [
    { key: "corpus", label: "Corpus", type: "currency", default: 50_00_000, min: 1000, max: 50_00_00_000 },
    { key: "withdrawal", label: "Withdrawal amount", type: "currency", default: 1_00_000, min: 500, max: 50_00_000 },
    {
      key: "frequency",
      label: "Withdrawal frequency",
      type: "select",
      default: "quarterly",
      options: [
        { value: "monthly", label: "Monthly" },
        { value: "quarterly", label: "Quarterly" },
        { value: "annual", label: "Annual" },
      ],
    },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 7, min: 1, max: 20, assumptionKey: "debtReturn" },
  ],
  chart: {
    type: "line",
    xKey: "year",
    series: [{ key: "balance", label: "Remaining balance", colorVar: "--gold" }],
  },
  compute(values) {
    const corpus = Number(values.corpus) || 0;
    const withdrawal = Number(values.withdrawal) || 0;
    const frequency = values.frequency || "quarterly";
    const annualRate = (Number(values.returnRate) || 0) / 100;

    const result = swpPeriodicWithdrawal(corpus, withdrawal, frequency, annualRate);
    const series = result.schedule.filter((row) => row.month % 12 === 0 || row.month === result.schedule.length).map((row) => ({ year: Math.round((row.month / 12) * 10) / 10, balance: row.balance }));

    return {
      headline: { label: "Corpus lasts", value: result.endMonth, format: "months" },
      breakdown: [
        { label: "Corpus", value: corpus },
        { label: `Withdrawal per ${FREQUENCY_LABELS[frequency] || "period"}`, value: withdrawal },
      ],
      series,
    };
  },
};

export default config;
